export function isLegacySystemPath(pathname: string): boolean {
  return pathname === "/legacy-system" || pathname.startsWith("/legacy-system/")
}
